export default __webpack_public_path__ + "static/media/client01.410f2448.jpg";